/* @flow weak */
import _ from 'lodash';
import React from 'react';
import Button from 'components/Button.jsx';
import { queryDirectAddJob, firstLastRequired } from 'groups/lib/directAdd';
import TableInput from 'components/TableInput.jsx';
import ToastActions from 'actions/ToastActions';
import Organization from 'entities/Organization';
import OrganizationActions from 'actions/OrganizationActions';
import EventTracking from 'lib/EventTracking.js';

import './styles/TeacherAddManualTabView.scss';

class TeacherAddManualTabView extends React.Component {
  static propTypes = {
    users: React.PropTypes.array,
    role: React.PropTypes.string,
    organization: React.PropTypes.instanceOf(Organization).isRequired,
    onSuccess: React.PropTypes.func,
    onUpdate: React.PropTypes.func,
  };

  static contextTypes = {
    eventScreenName: React.PropTypes.string,
  };

  state = {
    users: this.props.users,
  };

  onUpdate = (users) => {
    this.setState({ users });
    if (this.props.onUpdate) {
      this.props.onUpdate(users);
    }
  };

  onSuccess = (response) => {
    const { role } = this.props;
    queryDirectAddJob(this.props.organization.id, response.id).then((results) => {
      const numSuccessful = results.addedUsers.length + results.existingUsers.length;
      if (numSuccessful > 0) {
        const userText = numSuccessful === 1 ? role : role + 's';
        ToastActions.showSuccessToast(`${numSuccessful} ${userText} successfully added`);
        EventTracking.view('user_add_manual_success', { role, num_users_added: numSuccessful });
      }

      const previousUsers = this.state.users.filter(e => !_.isEmpty(e.fields));
      this.setState({ users: previousUsers.concat(results.errorUsers) });
      if (results.errorUsers.length === 0 && this.props.onSuccess) {
        this.props.onSuccess(results);
      }
    }, this.onFailure);
  };

  onFailure = () => {
    ToastActions.showDefaultErrorToast();
  };

  submitAddUsers = () => {
    const validUsers = [];
    const errorUsers = [];
    this.state.users.forEach(t => {
      if (t.isValid) {
        validUsers.push(t);
      } else if (!_.isEmpty(t.fields)) {
        errorUsers.push(t);
      }
    });

    const submitUsers = validUsers.map(t => {
      const name = t.fields.name || '';
      return {
        first_name: name.split(' ')[0],
        last_name: name.slice(name.indexOf(' ') + 1),
        address: t.fields.address.trim(),
      };
    });
    const { role, organization } = this.props;
    OrganizationActions.addUsers(submitUsers, role, organization.id)
      .then(this.onSuccess, this.onFailure);

    EventTracking.tap(
      this.context.eventScreenName,
      'add_users',
      { role: this.props.role, num_valid_users: validUsers.length, num_error_users: errorUsers.length },
    );

    this.setState({ users: errorUsers });
  };

  render() {
    const { users } = this.state;
    return (
      <div className="TeacherAddManualTabView">
        <div className="TeacherAddManualTabView-container">
          <TableInput
            initialRows={this.state.users}
            onChangeRow={this.onUpdate}
            autofocusFirstRow
            columns={[
              {
                name: 'name',
                label: 'Full name',
                placeholder: 'First and last name',
                validations: {
                  matchRegexp: /\w+ +\w+/,
                },
                validationErrors: {
                  matchRegexp: firstLastRequired,
                },
              },
              {
                name: 'address',
                label: 'Email address or phone number',
                placeholders: ['name@example.k12.us', '(555) 555-5555'],
                validations: 'isEmailOrPhone',
                validationError: 'Invalid phone or email',
              },
            ]}
          />
        </div>
        <div>
          <Button
            className="TeacherAddManualTabView-button"
            disabled={!users || users.filter(e => e.isValid).length === 0}
            onClick={this.submitAddUsers}
            level="primary"
            eventElementName="TeacherAddManualTabView-button">
            Add {this.props.role}s
          </Button>
        </div>
      </div>
    );
  }
}

export default TeacherAddManualTabView;



// WEBPACK FOOTER //
// ./src/groups/components/TeacherAddManualTabView.jsx